import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux";
import { PieChart, Pie, Sector, Cell, ResponsiveContainer, Tooltip, Legend, LabelList, Label, BarChart, Bar, CartesianGrid, XAxis, YAxis } from 'recharts';
import { bindActionCreators } from "redux";
import { Actions } from "../../Action";
import { getDomainsCountData } from "../../API/api";
import VizHeader from "../VizHeader/VizHeader";
import { Dropdown } from "antd"
import FileSaver, { saveAs } from "file-saver";
import * as htmlToImage from 'html-to-image';
import { useCurrentPng } from "recharts-to-png";
import { Tooltip as Tooltip2 } from "@mui/material";
import { ReactComponent as SettingIcon } from "./../../Icons/settings.svg";



import { Spin } from "antd";
import ChartToggleComponent from "../../NewComponent/ChartToggleComponent/ChartToggleComponent";
import TooltipComp from "../../NewComponent/ToolTip/TooltipComp";
export default function PieChartComponentForDomains() {
	const dispatch = useDispatch()
	const { getDomainListCountInOverview, getQuestionCountBreakdownData } = bindActionCreators(Actions, dispatch)
	const cmRootReducer = useSelector((state) => state.cmRoot)
	const expertOverview = useSelector((state) => state.expertOverviewCmReducer)
	const cmOverviewReducer = useSelector((state) => state.cmOverview)
	const [loading, setLoading] = useState(false)
	const [getCmTopics, setCmTopics] = useState([]);
	const userState = useSelector((state) => state.user);
	const [activeIndex, setActiveIndex] = useState(null);
	const [getPieChartPng, { ref: pieChartRef }] = useCurrentPng();
	const [totalCount, setTotalCount] = React.useState(0);
	const [dropdownToggle, setDropdowntoggle] = React.useState(false)
	const [activeChartType, setActiveChartType] = React.useState({ id: 1, type: 'pie' })
	const dropdownRef = React.useRef(null);

	useEffect(() => {
		const handleClickOutside = (event) => {
			if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
				setDropdowntoggle(false)
			}
		}
		if (dropdownToggle) {
			document.addEventListener('mousedown', handleClickOutside)
		} else {
			document.removeEventListener('mousedown', handleClickOutside)
		}
		return () => {
			document.removeEventListener("mousedown", handleClickOutside)
		}
	}, [dropdownToggle])

	const COLORS = [
		'#009BFF',
		'#00B8E6',
		'#B85CFF',
		'#5E3BFF',
		'#F4C900',
		'#EF7928',
		'#00C16E',
		'#7cb5ec',
		'#90ed7d',
		'#f7a35c',
		'#8085e9',
		'#f15c80',
		'#e4d354',
		'#2b908f',
		'#f45b5b',
		'#91e8e1',
		'#434348'];
	const RADIAN = Math.PI / 180;
	const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }) => {
		const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
		const x = cx + radius * Math.cos(-midAngle * RADIAN);
		const y = cy + radius * Math.sin(-midAngle * RADIAN);

		return (
			<text x={x} y={y} fill="white" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
				{`${(percent * 100).toFixed(0)}%`}
			</text>
		);
	};

	const onPieEnter = (_, index) => {
		setActiveIndex(index);
	};

	const onPieLeave = () => {
		setActiveIndex(-1);
	};

	const items = [
		{
			key: "1",
			label: (
				// <a target="_blank" rel="noopener noreferrer" href="https://www.antgroup.com">
				//   1st menu item
				// </a>
				<div onClick={() => handleAreaDownload()}>Download as PNG Image</div>
			),
		},
		{
			key: "2",
			label: (
				<div onClick={() => downloadSvgAsJpeg()}>Download as JPEG Image</div>
			),
		},
		{
			key: "4",
			label: (
				<div onClick={() => handleDownloadSVG()}>Download SVG Vector image</div>
			),
		},
	];

	// const handleAreaDownload = React.useCallback(async () => {
	// 	const png = await getPieChartPng();
	// 	console.log(png, 'check png')
	// 	if (png) {
	// 		FileSaver.saveAs(png, "pie-chart-domains.png");
	// 	}
	// }, [getPieChartPng]);

	const handleAreaDownload = () => {
		htmlToImage.toJpeg(document.getElementsByClassName('recharts-wrapper')[4], { quality: 0.8, backgroundColor: '#fff' }, { backgroundColor: '#fff' })
			.then(function (dataUrl) {
				var link = document.createElement('a');
				link.download = 'pie-chart-domains.png';
				link.href = dataUrl;
				link.click();
			});
	}
	function downloadSvgAsJpeg() {
		htmlToImage.toJpeg(document.getElementsByClassName('recharts-wrapper')[4], { quality: 0.8, backgroundColor: '#fff' }, { backgroundColor: '#fff' })
			.then(function (dataUrl) {
				var link = document.createElement('a');
				link.download = 'pie-chart-domains.jpeg';
				link.href = dataUrl;
				link.click();
			});

	}

	const handleDownloadSVG = () => {
		const chartContainer =
			document.getElementsByClassName("recharts-wrapper")[4];
		const chartSvg = chartContainer.querySelector("svg");
		const chartXml = new XMLSerializer().serializeToString(chartSvg);
		const svgBlob = new Blob([chartXml], {
			type: "image/svg+xml;charset=utf-8",
		});
		saveAs(svgBlob, "pie-chart-domains.svg");
	};

	const roundConditionally = (value) => {
		// If the decimal part is 0.5 or above, round up; otherwise, round down
		return value % 1 >= 0.5 ? Math.ceil(value) : Math.floor(value);
	};

	const renderActiveShape = (props) => {
		const RADIAN = Math.PI / 180;
		const { cx, cy, midAngle, innerRadius, outerRadius, startAngle, endAngle, fill, payload, percent, value } = props;
		const sin = Math.sin(-RADIAN * midAngle);
		const cos = Math.cos(-RADIAN * midAngle);
		const sx = cx + (outerRadius + 10) * cos;
		const sy = cy + (outerRadius + 10) * sin;
		const mx = cx + (outerRadius + 30) * cos;
		const my = cy + (outerRadius + 30) * sin;
		const ex = mx + (cos >= 0 ? 1 : -1) * 22;
		const ey = my;
		const textAnchor = cos >= 0 ? 'start' : 'end';

		return (
			<g>
				{/* <text x={cx} y={cy} dy={8} textAnchor="middle" fill={fill}>
			  {payload.name}
			</text> */}
				<Sector
					cx={cx}
					cy={cy}
					innerRadius={innerRadius}
					outerRadius={outerRadius}
					startAngle={startAngle}
					endAngle={endAngle}
					fill={fill}
					opacity={0.4}
					style={{ outline: 'none' }}

				/>
				<Sector
					cx={cx}
					cy={cy}
					startAngle={startAngle}
					endAngle={endAngle}
					innerRadius={outerRadius + 6}
					outerRadius={outerRadius + 10}
					fill={fill}
					style={{ outline: 'none' }}
				/>
				{/* <path d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`} stroke={fill} fill="none" /> */}
				{/* <circle cx={ex} cy={ey} r={2} fill={fill} stroke="none" /> */}
				{/* <text x={ex + (cos >= 0 ? 1 : -1) * 12} y={ey} textAnchor={textAnchor} fill="#333">{`${payload.name}`}</text>
			<text x={ex + (cos >= 0 ? 1 : -1) * 12} y={ey} dy={18} textAnchor={textAnchor} fill="#999">
			  {`${payload.value}`}
			</text> */}
			</g>
		);
	};

	const EmptyPieChart = () => {
		return (
			<div>
				<ResponsiveContainer width="100%" height={400}>
					<PieChart ref={pieChartRef}
					>
						<Pie dataKey="value" data={[{ name: 'No Data', value: 1 }]} fill="#8884d8">
							<Cell fill="#8884d8" />
						</Pie>
						<Legend />
					</PieChart>
				</ResponsiveContainer>
			</div>
		)
	};

	useEffect(() => {
		getDomainListCountInOverview([])
		if (cmRootReducer.selecetdRoutingValue !== "") {
			setLoading(true)
			getDomainsCountData(cmRootReducer.selecetdRoutingValue, cmRootReducer.selectedGeoLevel.length === 0 ? "" : cmRootReducer.selectedGeoLevel.label, cmRootReducer.selectedDomainIds, cmOverviewReducer.userTypeSelect.value).then((res) => {
				if (res === undefined) return;
				if (res.data.data !== undefined || res.data.success) {
					setLoading(false)
					let totalVal = Object.values(res.data.data).reduce((a, b) => a + b, 0)
					setTotalCount(totalVal)
					let newArray = Object.entries(res.data.data).map(([name, count], index) => {
						let countOfDomains = Object.values(res.data.data).reduce((a, b) => a + b, 0)
						let finalCount = (count / countOfDomains * 100).toFixed(1)
						let obj1 = { name: name, count: Math.floor(finalCount) > 0 ? roundConditionally(finalCount) : 1, Searches: count, totalCount: countOfDomains, index: index }
						return obj1;
					})
					// var array1 = Object.entries(res.data.data).sort().map(([date, value]) => ({date,value}));
					getDomainListCountInOverview(newArray)

					// let totalVal = Object.values(newData).reduce((a, b) => a + b, 0)
					// setTotalCount(totalVal)
					// let newArray = Object.entries(newData).map(([name, count]) => {
					// 	let countOfDomains = Object.values(newData).reduce((a, b) => a + b, 0)
					// 	let finalCount = (count/countOfDomains*100).toFixed(1)
					// 	let obj1 = { name: name, count:Math.floor(finalCount) > 0 ? Math.floor(finalCount) :1, Searches: count, totalCount: countOfDomains }
					// 	return obj1;
					// })
					// // var array1 = Object.entries(res.data.data).sort().map(([date, value]) => ({date,value}));
					// getDomainListCountInOverview(newArray)
					setCmTopics(Object.values(userState.cmTopics))
				}
			})
		}
		// return()=>{
		// 	getDomainListCountInOverview([])
		// }
	}, [cmRootReducer.selecetdRoutingValue, cmRootReducer.selectedDomainIds, cmRootReducer.selectedGeoLevel.label, cmOverviewReducer.userTypeSelect])

	const CustomizedTooltip = ({ active, payload, label }) => {
		if (active && payload && payload.length > 0 && activeChartType.id === 1) {
			return (
				<div style={{ fontWeight: 'bold', backgroundColor: '#fff', padding: '5px', fontSize: '12px', border: `1px solid ${payload[0].payload.fill}`, transition: 'ease-in-out' }} className='custom-tooltip'>
					{payload[0].name}:{" "}{payload[0].payload?.count + `%`}
					<p className="label">No. of Searches:{" "}{payload[0].payload.Searches.toLocaleString()}</p>
				</div>
			)
		}
		if (active && payload && payload.length > 0 && activeChartType.id === 2) {
			const item = payload[0];
			const index = item.payload.index;
			return (
				// <div style={{ fontWeight: 'bold', backgroundColor: '#fff', padding: '5px', fontSize: '12px', border: `1px solid ${payload[0].payload.fill}`, transition: 'ease-in-out' }} className='custom-tooltip'>
				// 	{payload[0].name}:{" "}{payload[0].payload?.count + `%`}
				// 	<p className="label">No. of Searches:{" "}{payload[0].payload.Searches.toLocaleString()}</p>
				// </div>
				<>
					<div style={{ fontWeight: 'bold', backgroundColor: '#fff', padding: '5px', fontSize: '12px', border: `1px solid ${COLORS[index % COLORS.length]}`, transition: 'ease-in-out' }} className='custom-tooltip'>
						{payload[0]?.payload?.name}:{" "}{`${payload[0]?.value}%`}
						<div>No. of Searches:{" "}{payload[0].payload?.Searches.toLocaleString()}</div>
					</div>
				</>
			)
		}
	}

	const renderLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index, payload }) => {
		if (expertOverview.getDomainListCount.length > 0) {
			// Calculate the coordinates for placing the label
			const RADIAN = Math.PI / 180;
			const x = cx + (outerRadius + 24) * Math.cos(-midAngle * RADIAN);
			const y = cy + (outerRadius + 35) * Math.sin(-midAngle * RADIAN);

			// Calculate percentage value
			const percentage = Math.floor((expertOverview.getDomainListCount[index].Searches / totalCount) * 100);

			// Return the label with percentage value
			if (payload) {
				return (
					<>
						<text
							x={x}
							y={y}
							fill={payload.count > 0 && payload.fill}
							// fill={payload?.fill}
							textAnchor={x > cx ? 'start' : 'end'}
							dominantBaseline="central"
						>
							{/* {payload && payload.count > 0 && payload.name}{payload.count > 0 && ':'}{" "}{payload.count > 0 &&`${percentage}%`} */}
							{
								payload.count > 0 &&
								payload.name + ": " + payload?.count + `%`}
						</text>
					</>
				);
			}
		}
	};

	const handleLabelLine = (props) => {
		const { value, name } = props;
		if (value === 0) {
			// Return null to hide the label line when the value is zero
			return null;
		}
		else {
			// console.log({}, 'check default ')
		}
		// Return an empty object to use the default label line style
		return {}
	};

	const onClickChangeChartType = (val) => {
		setActiveChartType(val)
	}

	const tickFormatter = (value) => {
		const limit = 10;
		if (value.length < limit) return value;
		else
			return `${value.substring(0, limit)}...`;
	};

	const CustomTick = ({ x, y, stroke, payload }) => {
		if (payload) {
			return (
				<>
					<Tooltip2 title={payload.value} placement="top">
						<g transform={`translate(${x},${y})`}>
							<text fontSize={12} x={0} y={0} dy={14} textAnchor="end" fill="#666" transform="rotate(-35)">
								{tickFormatter(payload.value)}
							</text>
						</g>
					</Tooltip2>
				</>
			)
		}
	}

	// console.log(Math.max(10,
	// 	(400 - 10 * expertOverview.getDomainListCount.length) / expertOverview.getDomainListCount.length),'check ')

	return (
		<>




			<div style={{ position: 'relative', padding: '10px', backgroundColor: '#fff', borderRadius: '8px' }}>
				{/* Header */}
				<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'relative' }}>

					{/* <VizHeader type={4} isBold={true}>Question Volume Trend</VizHeader> */}
					<span style={{ width: "100%", display: "flex", justifyContent: "center" }}>
						<VizHeader type={4} isBold={true}>Search Volumes By Domain</VizHeader>
					</span>
					<div style={{ flex: 1 }} />

					<div style={{ textAlign: 'center' }}>

					</div>
					<div style={{ position: 'absolute', right: 0, top: 0, padding: '5px' }}>
						<SettingIcon style={{ fontSize: '24px', cursor: 'pointer', }} onClick={() => setDropdowntoggle(!dropdownToggle)} />

						{/* {<i onClick={() => setDropdowntoggle(!dropdownToggle)} className="fa fa-gear" style={{ fontSize: '24px', cursor: 'pointer' }} />} */}
					</div>
				</div>

				{/* Chart */}
				<Spin spinning={loading}>
					{(cmRootReducer.selectedDomainIds !== '' && expertOverview.getDomainListCount.length > 0) &&
						(activeChartType.id === 1) &&
						<ResponsiveContainer width="100%" height={400}>
							<PieChart ref={pieChartRef}>
								<Pie
									activeShape={renderActiveShape}
									isAnimationActive={true}
									data={expertOverview?.getDomainListCount}
									cx="50%"
									cy="50%"
									outerRadius={130}
									innerRadius={65}
									fill="#8884d8"
									dataKey="count"
									// animationEasing="ease-in-out"
									paddingAngle={1}
									minAngle={8}
									label={renderLabel}
									onMouseEnter={onPieEnter}
									onMouseLeave={onPieLeave}
								// labelLine={handleLabelLine}
								>
									{expertOverview.getDomainListCount.length > 0 && getCmTopics.length > 0 && getCmTopics?.map((entry, index) => (
										<Cell style={{ outline: 'none' }} key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
									))}
								</Pie>
								<Tooltip wrapperStyle={{ fontSize: '12px', fontWeight: 'bold' }} content={<CustomizedTooltip />} />
								{/* <Legend wrapperStyle={{ fontSize: '12px' }} /> */}
							</PieChart>
						</ResponsiveContainer>}
					{

						(cmRootReducer.selectedDomainIds === '' || expertOverview.getDomainListCount.length === 0) && (activeChartType.id === 1) &&
						(
							<EmptyPieChart />
						)
					}
					{
						(cmRootReducer.selectedDomainIds !== '' && expertOverview.getDomainListCount.length > 0) &&
						(activeChartType.id === 2) && (
							<>
								<ResponsiveContainer width="100%" height={400}>
									<BarChart ref={pieChartRef} data={expertOverview.getDomainListCount}
										margin={{
											top: 5,
											right: 40,
											left: 20,
											bottom: 40,
										}}
									>
										<CartesianGrid stroke="#ececec" vertical={false} />
										<XAxis tick={<CustomTick />} angle={-45} tickMargin={2} offset={7} dy={10} dx={2} interval={"equidistantPreserveStart"} tickLine style={{ fontSize: '12px' }} dataKey={'name'} >
											<Label value={'Domains'} />
										</XAxis>
										<YAxis dataKey={'count'} style={{ fontSize: '12px' }} allowDecimals={false} axisLine={false} tickLine={false} max={100} >
											<Label value={"Percentage"} angle={-90} fontWeight="bold" dx={-22} />
										</YAxis>
										<Tooltip cursor={false} content={<CustomizedTooltip />} wrapperStyle={{ fontSize: '12px', fontWeight: 'bold' }} />
										<Bar dataKey={'count'} barSize={24}>
											{expertOverview.getDomainListCount.length > 0 && getCmTopics.length > 0 && getCmTopics?.map((entry, index) => (
												<Cell style={{ outline: 'none' }} key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
											))}
										</Bar>
									</BarChart>
								</ResponsiveContainer>
							</>
						)
					}
					{
						(expertOverview.getDomainListCount.length === 0) &&
						(activeChartType.id === 2) && (
							<ResponsiveContainer width="100%" height={400}>
								<BarChart data={expertOverview.getDomainListCount}>
									<CartesianGrid strokeDasharray="3 3" />
									<XAxis dataKey="name" />
									<YAxis />
									<Tooltip />
									<Bar dataKey="value" fill="#8884d8" />
								</BarChart>
							</ResponsiveContainer>
						)}
				</Spin>
				{/* Floating Settings Panel */}
				{dropdownToggle && (
					<div
						ref={dropdownRef}
						style={{
							position: 'absolute',
							top: '50px',
							right: '10px',
							width: '240px',
							backgroundColor: '#fff',
							padding: '12px',
							border: '1px solid #ccc',
							borderRadius: '8px',
							boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
							zIndex: 10
						}}>
						<div style={{ textAlign: 'end' }}>
							<i
								onClick={() => setDropdowntoggle(false)}
								className="fa fa-close"
								style={{ fontSize: '18px', cursor: 'pointer' }}
							/>

						</div>


						<div style={{ textAlign: 'end', marginBottom: '10px' }}>
							<ChartToggleComponent value={activeChartType} onClickFunction={() => onClickChangeChartType({ id: 1, type: 'pie' })} fontSize={'24px'} type={'pie'} />

							&nbsp;&nbsp;
							<ChartToggleComponent value={activeChartType} onClickFunction={() => onClickChangeChartType({ id: 2, type: 'bar' })} type={'bar'} fontSize={'24px'} />

						</div>

						{['PNG', 'JPEG', 'SVG'].map((format, i) => {
							const handleClick = [handleAreaDownload, downloadSvgAsJpeg, handleDownloadSVG][i];
							return (
								<div key={format} style={{
									marginBottom: '10px',
									textAlign: 'end',
									color: '#5c667b',
									fontSize: '14px'
								}}>
									<span>Download {format}</span>{" "}
									<span onClick={handleClick} style={{ border: '1px solid #d9d9d9', padding: '7px', cursor: 'pointer' }}>
										<i className="fa fa-download" />
									</span>
								</div>
							);
						})}
					</div>
				)}
			</div>
		</>
	)
}